import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuardService } from './services/auth/auth-guard.service';
import { LoginComponent } from '@components/login/login.component';
import { DealPageComponent } from '@components/pages/deal-page/deal-page.component';
import { RememberPasswordComponent } from '@components/login/remember-password/remember-password.component';
import { NotFoundComponent } from '@components/pages/not-found/not-found.component';
import { HomeComponent } from '@components/pages/home/home.component';
import { ActivateComponent } from '@components/login/activate/activate.component';

const routes: Routes = [
    { path: '', redirectTo: '/login', pathMatch: 'full' },
    {
        path: 'login',
        component: LoginComponent,
    },
    {
        path: 'activate/:uidb/:token',
        component: ActivateComponent,
    },
    {
        path: '',
        component: HomeComponent,
        canActivate: [AuthGuardService],
        data: {
            breadcrumb: 'Atalaya',
            permissions: ['app_deals', 'app_dealflow'],
        },
        children: [
            {
                path: 'my-page',
                component: DealPageComponent,
                canActivate: [AuthGuardService],
                data: {
                    breadcrumb: 'Detalle de la compañía',
                    permissions: ['app_deals', 'app_dealflow'],
                },
            },
        ],
    },
    {
        path: 'remember-password',
        component: RememberPasswordComponent,
    },
    {
        path: 'remember-password/:token',
        component: RememberPasswordComponent,
    },
    { path: '404', component: NotFoundComponent },
    { path: '**', redirectTo: '/404' },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
